module.exports = __webpack_public_path__ + "static/media/Restriction_Enzyme_HaeIII_RE.65c245e4.svg";